import React from 'react';
import { motion } from 'framer-motion';
import QRCode from 'react-qr-code';
import DevicePhoneIcon from '../common/icons/DevicePhoneIcon';
import ClipboardIcon from '../common/icons/ClipboardIcon';

const QRCodeDisplay = ({ qrCode, customerName, orderId, total }) => {
  const normalizedCustomerName = customerName?.trim().length
    ? customerName.trim()
    : 'NEZNAMY_ZAKAZNIK';

  const fallbackQrCode = `QR_${orderId ?? 'ORD000'}_${normalizedCustomerName
    .replace(/\s+/g, '_')
    .toUpperCase()}`;

  // QR kód obsahuje URL na schválenie platby
  const baseQrCode = qrCode?.trim().length ? qrCode.trim() : fallbackQrCode;
  const qrCodeValue = typeof window !== 'undefined' 
    ? `${window.location.origin}/approve.html?qr=${encodeURIComponent(baseQrCode)}`
    : baseQrCode;


  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      className="bg-gradient-to-br from-slate-900 via-slate-950 to-slate-900 rounded-2xl p-6 border-2 border-dashed border-primary-500/40 text-center text-slate-100 shadow-lg"
    >
      <div className="text-6xl mb-4 flex justify-center" aria-hidden="true">
        <DevicePhoneIcon className="text-5xl text-primary-300" />
      </div>

      <h3 className="text-2xl font-bold text-primary-100 mb-2">
        Váš QR kód na platbu
      </h3>

      <p className="text-slate-300 mb-6">
        Ukážte tento kód organizátorovi na potvrdenie platby
      </p>

      {/* QR kód */}
      <div className="bg-slate-900 rounded-xl p-6 mb-6 shadow-lg inline-block border border-slate-800">
        <div className="p-2 border border-slate-700 rounded-xl bg-slate-950">
          <QRCode
            value={qrCodeValue}
            size={192}
            className="mx-auto"
            aria-label={`QR kód pre objednávku ${orderId ?? ''}`}
          />
        </div>

        <div className="font-mono text-sm text-primary-100 bg-slate-950 p-3 rounded border border-slate-800 break-all mt-4">
          {qrCodeValue}
        </div>
      </div>

      {/* Pokyny */}
      <div className="text-left max-w-md mx-auto">
        <h4 className="font-semibold text-primary-100 mb-3 flex items-center gap-2">
          <ClipboardIcon className="text-primary-300" aria-hidden="true" />
          <span>Postup platby:</span>
        </h4>
        <ol className="text-sm text-slate-300 space-y-2">
          <li className="flex items-start gap-2">
            <span className="bg-primary-500 text-slate-950 rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold flex-shrink-0 mt-0.5">
              1
            </span>
            <span>Prejdite k organizátorovi na mieste podujatia</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="bg-primary-500 text-slate-950 rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold flex-shrink-0 mt-0.5">
              2
            </span>
            <span>Ukážte tento QR kód z emailu alebo obrazovky</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="bg-primary-500 text-slate-950 rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold flex-shrink-0 mt-0.5">
              3
            </span>
            <span>
              Zaplaťte <strong className="text-primary-100">{total}€ v hotovosti</strong>
            </span>
          </li>
          <li className="flex items-start gap-2">
            <span className="bg-primary-500 text-slate-950 rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold flex-shrink-0 mt-0.5">
              4
            </span>
            <span>Vaše lístky budú aktivované do tomboly</span>
          </li>
        </ol>
      </div>


      <div className="mt-4 text-xs text-slate-400">
        <p>QR kód je platný do schválenia platby organizátorom</p>
      </div>
    </motion.div>
  );
};

export default QRCodeDisplay;